export default {
  areas: {
    hero: {
      eyebrow: 'منطقة الخدمة',
      title: 'كاميرات مراقبة وأنظمة إنذار في كامل منطقة راين-ماين',
      subtitle: 'من فرانكفورت مرورًا بأوفنباخ وهاناو ودارمشتات وصولًا إلى غروس-غيراو: تخطط SSG Signaltechnik وتثبّت وتدير المراقبة بالفيديو وأنظمة الإنذار للأفراد والشركات – شخصيًا وفي الموقع.',
      ctaPrimary: 'اطلب استشارة أولى مجانية',
      ctaSecondary: 'اكتشف المراقبة بالفيديو',
    },
    breadcrumbHome: 'الرئيسية',
    breadcrumbCurrent: 'منطقة الخدمة',
    intro: {
      eyebrow: 'أين نعمل من أجلك',
      title: 'مسافات قصيرة في كامل المنطقة',
      p1: 'شركتنا المتخصصة في تقنية الأمان مقرها هاينبورغ – وتتنقل بسرعة في كامل منطقة راين-ماين. كاميرا مراقبة أو مراقبة بالفيديو أو نظام إنذار: نأتي إليك ونحلل مبنىك في الموقع ونركّب كل شيء بنظافة واحتراف.',
      p2: 'سواء منزل خاص أو عمارة أو محل تجاري أو مكتب أو مستودع أو ورشة – نتعامل مع مشاريع بجميع الأحجام في فرانكفورت وأوفنباخ وهاناو ودارمشتات وغروس-غيراو وكل المدن والبلديات المجاورة.',
    },
    city: 'مدينة',
    district: 'مقاطعة',
    coverage: {
      eyebrow: 'متجذرون محليًا',
      title: 'شركتك المتخصصة من المنطقة – للمنطقة',
      p1: 'كشركة محلية متخصصة في تقنية الأمان في منطقة راين-ماين، نعرف المتطلبات والظروف في الموقع. بالنسبة لكاميرا المراقبة أو نظام الإنذار: مسافات قصيرة وأشخاص للتواصل ومواعيد سريعة.',
      p2: 'نتنقل أيضًا خارج منطقة راين-ماين حسب الاتفاق. تواصل معنا – وسنتحقق بكل سرور مما هو ممكن لمشروعك.',
      ctaPrimary: 'استفسر الآن',
      ctaSecondary: 'اكتشف أنظمة الإنذار',
      caption: 'تركيب وإعداد شخصي في الموقع – من هاينبورغ في كامل منطقة راين-ماين.',
    },
    cta: {
      title: 'كاميرا مراقبة أم نظام إنذار لمبناك؟',
      lead: 'ننصحك دون التزام ونريك الحل الذي يناسب مبنىك وميزانيتك – في كامل منطقة راين-ماين ومحيطها.',
      primary: 'اطلب استشارة أولى مجانية',
      secondary: 'ابدأ مخطط الكاميرات',
    },
  },
};